// extracted by mini-css-extract-plugin
export var aboveInput = "_l6-0";
export var actionButton = "_l6-5";
export var actionButtonContainer = "_l6-1";
export var actionIcon = "_l6-6";
export var aiInfoContainer = "_l6-2";
export var attachmentWrapper = "_l6-7";
export var bold = "_l6-3";
export var checkIcon = "_l6-8";
export var clickingRecipientBar = "_l6-11";
export var commentThreadSwitch = "_l6-a";
export var draftImage = "_l6-b";
export var draftImageContainer = "_l6-c";
export var draftImages = "_l6-e";
export var editButton = "_l6-g";
export var editor = "_l6-f";
export var editorContainer = "_l6-y";
export var editorErrorTooltipWrapper = "_l6-9";
export var headerDivider = "_l6-h";
export var icon = "_l6-i";
export var info = "_l6-j";
export var internal = "_l6-n";
export var internalDivider = "_l6-k";
export var internalMessage = "_l6-l";
export var messageInputCard = "_l6-m";
export var messageInputForm = "_l6-o";
export var messageInputFormInternal = "_l6-p";
export var options = "_l6-q";
export var publicMessageCustomer = "_l6-s";
export var publicMessageMerchant = "_l6-r";
export var removeImageButton = "_l6-d";
export var replyButtons = "_l6-t";
export var showSignatureButton = "_l6-u";
export var spinner = "_l6-v";
export var verticalButtonDivider = "_l6-4";
export var visibilitySelector = "_l6-w";
export var warning = "_l6-x";
export var wrappingText = "_l6-z";
export var writingInternalNoteTopBorder = "_l6-10";